export default __webpack_public_path__ + "static/brand-image_2x-b88f37dd6f462361a55451a799ea13e8.jpg";